<template>
  <div>
    <el-table :data="codelist" style="width: 100%" resizable border>
      <el-table-column
        label="id"
        prop="id"
        fixed
        width="100px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="descCode"
        prop="descCode"
        fixed
        width="200px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="descUse"
        prop="descUse"
        width="240px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="简体中文"
        prop="chinese"
        align="center"
      ></el-table-column>
      <el-table-column
        label="繁体中文"
        prop="hongkong"
        align="center"
      ></el-table-column>
      <el-table-column
        label="英语"
        prop="english"
        align="center"
      ></el-table-column>
      <el-table-column
        label="日语"
        prop="japanese"
        align="center"
      ></el-table-column>
      <el-table-column
        label="韩语"
        prop="korean"
        align="center"
      ></el-table-column>
      <el-table-column
        label="俄语"
        prop="russian"
        align="center"
      ></el-table-column>
      <el-table-column
        label="越南语"
        prop="vietnam"
        align="center"
      ></el-table-column>
      <el-table-column
        label="印地语"
        prop="hindi"
        align="center"
      ></el-table-column>
      <el-table-column
        label="印尼语"
        prop="indonesian"
        align="center"
      ></el-table-column>
      <el-table-column
        label="西班牙语"
        prop="spanish"
        align="center"
      ></el-table-column>
      <el-table-column
        label="土耳其语"
        prop="turkish"
        align="center"
      ></el-table-column>
      <el-table-column
        label="泰语"
        prop="thailand"
        align="center"
      ></el-table-column>
      <el-table-column
        label="葡萄牙语"
        prop="portugal"
        align="center"
      ></el-table-column>
      <el-table-column
        label="阿拉伯语"
        prop="arab"
        align="center"
      ></el-table-column>
      <el-table-column
        label="法语"
        prop="french"
        align="center"
      ></el-table-column>

      <el-table-column label="操作" fixed="right" width="140px" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="修改国际化配置"
      width="800px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="descCode" prop="descCode">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="ruleForm.descCode"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="descUse" prop="descUse">
          <el-input
            type="textarea"
            placeholder="请输入用途说明"
            v-model="ruleForm.descUse"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="中文" prop="chinese">
          <el-input
            type="textarea"
            placeholder="请输入中文"
            v-model="ruleForm.chinese"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="繁体" prop="hongkong">
          <el-input
            type="textarea"
            placeholder="请输入繁体"
            v-model="ruleForm.hongkong"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="英语" prop="english">
          <el-input
            type="textarea"
            placeholder="请输入英语"
            v-model="ruleForm.english"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="日语" prop="japanese">
          <el-input
            type="textarea"
            placeholder="请输入日语"
            v-model="ruleForm.japanese"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="韩语" prop="korean">
          <el-input
            type="textarea"
            placeholder="请输入韩语"
            v-model="ruleForm.korean"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="俄语" prop="russian">
          <el-input
            type="textarea"
            placeholder="请输入俄语"
            v-model="ruleForm.russian"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="越南语" prop="vietnam">
          <el-input
            type="textarea"
            placeholder="请输入越南语"
            v-model="ruleForm.vietnam"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="印地语" prop="hindi">
          <el-input
            type="textarea"
            placeholder="请输入印地语"
            v-model="ruleForm.hindi"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="印尼" prop="indonesian">
          <el-input
            type="textarea"
            placeholder="请输入印尼"
            v-model="ruleForm.indonesian"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="西班牙语" prop="spanish">
          <el-input
            type="textarea"
            placeholder="请输入西班牙语"
            v-model="ruleForm.spanish"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="土耳其语" prop="turkish">
          <el-input
            type="textarea"
            placeholder="请输入土耳其"
            v-model="ruleForm.turkish"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="泰语" prop="thailand">
          <el-input
            type="textarea"
            placeholder="请输入泰语"
            v-model="ruleForm.thailand"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="葡萄牙语" prop="portugal">
          <el-input
            type="textarea"
            placeholder="请输入葡萄牙语"
            v-model="ruleForm.portugal"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="阿拉伯语" prop="arab">
          <el-input
            type="textarea"
            placeholder="请输入阿拉伯语"
            v-model="ruleForm.arab"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="法语" prop="french">
          <el-input
            type="textarea"
            placeholder="请输入法语"
            v-model="ruleForm.french"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label-width="300px">
          <el-button type="primary" @click="updateCode('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')"
          >保存</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import {
  ValidateCode,
  ValidateEN,
  ValidateLocale,
  ValidateZH,
} from "../../validate.js";
export default {
  props: ["currentSize", "currentPage", "descCode", "chinese"],
  data() {
    return {
      dialogVisibleChange: false,
      result: true,
      ruleForm: {},
      upperList: [],
      rules: {
        descCode: [
          { required: true, message: "请输入descCode", trigger: "blur" },
        ],
        english: [
          // { required: true, validator: ValidateEN, trigger: "blur" },
          { required: true, message: "请输入英文内容", trigger: "blur" },
        ],
        chinese: [
          { required: true, message: "请输入中文内容", trigger: "blur" },
          // { required: true, validator: ValidateZH, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getDataList({
      page: this.currentPage,
      size: this.currentSize,
      descCode: this.descCode,
      chinese: this.chinese,
    });
  },
  computed: {
    ...mapState("config-i18n", ["codelist"]),
    ...mapGetters("config-i18n", ["filterList"]),
    list() {
      return this.filterList.map((item) => item.locale.toUpperCase());
    },
  },
  methods: {
    ...mapActions("config-i18n", ["getlist", "delOne", "updateOne"]),
    async getDataList({ descCode, chinese, page, size }) {
      const res = await this.getlist({ descCode, chinese, page, size });
      // this.codelist=res.data.list
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.resetForm("ruleForm");
        })
        .catch((_) => {});
    },
    handleEdit(index, row) {
      this.dialogVisibleChange = true;
      // this.ruleForm = Object.assign(this.ruleForm, { ...row });
      this.ruleForm = { ...row };
    },
    handleDelete(index, row) {
      const id = row.id;

      this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.delOne(id);
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.getDataList({
              page: this.currentPage,
              size: this.currentSize,
              descCode: this.descCode,
              chinese: this.chinese,
            });
          } else {
            this.$message.error("操作失败！请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    hadnleLanguageTypeChange(coinType, status) {},

    updateCode(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await this.updateOne({
            id: this.ruleForm.id,
            data: this.ruleForm,
          });

          if (res.code == 0) {
            this.$message.success("操作成功");
            this.dialogVisibleChange = false;
            this.getDataList({
              page: this.currentPage,
              size: this.currentSize,
              descCode: this.descCode,
              chinese: this.chinese,
            });
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // this.ruleForm={
      //   descCode:'',
      //   id:this.ruleForm.id,
      //   chinese:'',
      //   english:'',
      //   japanese:'',
      //   korean:'',
      //   turkish:'',
      //   Vietnam:'',
      // }
    },
    closeDialog() {},
  },
};
</script>

<style lang="less" scoped></style>
